import { Behavior } from "../../base/Behavior";
import { SlideoutDecorator } from "./SlideoutDecorator";
import { Button } from "../../components/button/Button";

export class SlideoutDecoratorBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public addCloseButton(decorator: SlideoutDecorator, closeButton: Button): void {
        decorator.panelHeader.add(closeButton);
    }

    public performSlideIn(decorator: SlideoutDecorator): Promise<any> {
        return decorator.slideInAndFill(
            decorator.fillHorizontalSpace,
            decorator.fillVerticalSpace,
            decorator.transitionOptions,
            decorator.displayOverlay,
            decorator.overlayProps
        );
    }

    get type(): string {
        return "SlideoutDecorator";
    }
}

SlideoutDecoratorBehavior.register();
